// Adopted heavily from '@angular/service-worker' source code:
// https://github.com/angular/angular/blob/7cabaa0ae745dfbbad664b71da70eec89c17c744/packages/service-worker/src/module.ts

import { NgModule, PLATFORM_ID } from '@angular/core';

import { WindowService } from '../shared/services/window.service';
import { ClientStartupConfigService } from '../shared/shared-context/client-startup-config.service';
import { serviceWorkerApiAvailableFactory } from './service-worker-api-available.factory';
import { SERVICE_WORKER_API_AVAILABLE } from './service-worker-api-available.injection-token';
import { ServiceWorkerConfigService } from './service-worker-config.service';
import { serviceWorkerEnabled } from './service-worker-enabled.factory';
import { SERVICE_WORKER_ENABLED } from './service-worker-enabled.injection-token';
import { serviceWorkerUserIdFactory } from './service-worker-user-id.factory';
import { SERVICE_WORKER_USER_ID_FACTORY } from './service-worker-user-id.injection-token';

@NgModule({
    providers: [
        {
            provide: SERVICE_WORKER_API_AVAILABLE,
            useFactory: serviceWorkerApiAvailableFactory,
            deps: [WindowService, PLATFORM_ID]
        },
        {
            provide: SERVICE_WORKER_ENABLED,
            useFactory: serviceWorkerEnabled,
            deps: [ServiceWorkerConfigService, SERVICE_WORKER_API_AVAILABLE]
        },
        {
            provide: SERVICE_WORKER_USER_ID_FACTORY,
            useFactory: serviceWorkerUserIdFactory,
            deps: [ClientStartupConfigService]
        }
    ]
})
export class ServiceWorkerModule {
}
